import * as React from "react";
import { connect } from "react-redux";
import {
  match as Match,
  NavLink,
  Route,
  Switch,
  withRouter
} from "react-router-dom";
import {
  getCreditLensPathPrefix,
  isCreditLensFeatureEnabled
} from "../configState/selector";
import selectorsToProps from "../utils/selectorsToProps";
import "./SideNav.scss";

interface SideNavContentsProps {
  match: Match<{ id: string; environmentName?: string; status?: string }>;
  isCreditLensFeatureEnabled: boolean;
}

const SideNavContents = class extends React.Component<SideNavContentsProps> {
  constructor(props: SideNavContentsProps) {
    super(props);
  }

  public render() {
    const { match } = this.props;
    return (
      <>
        <ul className="SideNav__nav">
          {this.props.isCreditLensFeatureEnabled ? null : (
            <li className="SideNav__nav-item">
              <NavLink
                className="SideNav__nav-link SideNav__nav-link--root"
                activeClassName="SideNav__nav-link--active"
                to="/spreads"
                exact={true}
              >
                <div className={"SideNav__nav-image SideNav__nav-image-back"} />
                <span className="SideNav__nav-name">All Spreads</span>
              </NavLink>
            </li>
          )}
          <li className="SideNav__nav-item">
            <NavLink
              className="SideNav__nav-link"
              activeClassName="SideNav__nav-link--active"
              to={`${match.url}`}
              exact={true}
            >
              <div
                className={"SideNav__nav-image SideNav__nav-image-spreadView"}
              />
              <span className="SideNav__nav-name">Chart</span>
            </NavLink>
          </li>
          <li className="SideNav__nav-item">
            <NavLink
              className="SideNav__nav-link"
              activeClassName="SideNav__nav-link--active"
              to={`${match.url}/auditLog`}
              exact={true}
            >
              <div
                className={"SideNav__nav-image SideNav__nav-image-auditLog"}
              />
              <span className="SideNav__nav-name">History</span>
            </NavLink>
          </li>
          <li className="SideNav__nav-item">
            <NavLink
              className="SideNav__nav-link"
              activeClassName="SideNav__nav-link--active"
              to={`${match.url}/comments`}
              exact={true}
            >
              <div
                className={"SideNav__nav-image SideNav__nav-image-readComment"}
              />
              <span className="SideNav__nav-name">Comments</span>
            </NavLink>
          </li>
        </ul>
      </>
    );
  }
};

const ConnectedSideNavContents = connect(
  selectorsToProps({ isCreditLensFeatureEnabled })
)(SideNavContents);

const HomeNav = () => {
  return (
    <>
      <ul className="SideNav__nav">
        <li className="SideNav__nav-item">
          <NavLink
            className="SideNav__nav-link"
            activeClassName="SideNav__nav-link--active"
            to={"/spreads"}
            exact={true}
          >
            <div
              className={"SideNav__nav-image SideNav__nav-image-documentsView"}
            />
            <span className="SideNav__nav-name">Spreads</span>
          </NavLink>
        </li>
        <li className="SideNav__nav-item">
          <NavLink
            className="SideNav__nav-link"
            activeClassName="SideNav__nav-link--active"
            to={"/entities"}
            exact={true}
          >
            <div className={"SideNav__nav-image SideNav__nav-image-entities"} />
            <span className="SideNav__nav-name">Entities</span>
          </NavLink>
        </li>
      </ul>
    </>
  );
};

const EntityNav = () => {
  return (
    <>
      <ul className="SideNav__nav">
        <li className="SideNav__nav-item">
          <NavLink
            className="SideNav__nav-link SideNav__nav-link--root"
            activeClassName="SideNav__nav-link--active"
            to="/entities"
            exact={true}
          >
            <div className={"SideNav__nav-image SideNav__nav-image-back"} />
            <span className="SideNav__nav-name">Entities</span>
          </NavLink>
        </li>
      </ul>
    </>
  );
};

interface SideNavProps {
  creditLensPathPrefix: string;
}

const SideNav: React.SFC<SideNavProps> = ({ creditLensPathPrefix }) => {
  const [chevronClick, setChevronClick] = React.useState(false);
  const onChevronClick = () => {
    setChevronClick(!chevronClick);
  };
  return (
    <div className={chevronClick ? "SideNav__open" : "SideNav"}>
      <Switch>
        <Route exact={true} path="/spreads" component={HomeNav} />
        <Route exact={true} path="/entities" component={HomeNav} />
        <Route
          path="/spreads/:id/:environmentName/:status"
          component={SideNavContents}
        />
        <Route path="/entity/:id/" component={EntityNav} />
        <Route
          path={`${creditLensPathPrefix}/spreads/:id`}
          component={ConnectedSideNavContents}
        />
      </Switch>
      <div
        onClick={onChevronClick}
        className="SideNav__nav-double-angel__outer"
      >
        <div className="SideNav__nav-double-angel" />
      </div>
    </div>
  );
};

export default withRouter(connect(
  selectorsToProps({ creditLensPathPrefix: getCreditLensPathPrefix })
)(SideNav) as any);



// WEBPACK FOOTER //
// ./src/sideNav/SideNav.tsx